import React from 'react'
import { Typography } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import ButtonComponent from '../../utils/MatrialUiComponents/Button/ButtonComponent'
import DialogBox from '../../utils/MatrialUiComponents/DialogBox/DialogBox'
import StylesWithMaterialUi from './DeleteFleet.styles'
// eslint-disable-next-line import/no-cycle
import useController from './DeleteFleet.controller'

const DeleteFleet = (props) => {
  const { fleetId, drawer, name } = props
  const { handleDelete, handleCancelPopup, open, handlePopup, refDialog, t } =
    useController(props)
  const classes = StylesWithMaterialUi()

  return (
    <>
      {drawer ? (
        <ButtonComponent
          startIcon={<DeleteIcon />}
          tooltiptitle={t('v_detail.btn_delete')}
          size="small"
          onClick={(e) => handleDelete(e, fleetId)}
          className={classes.button}
        >
          {t('v_detail.btn_delete')}
        </ButtonComponent>
      ) : (
        <Typography
          onClick={(e) => handleDelete(e, fleetId)}
          style={{
            fontFamily: 'Comfortaa',
            fontWeight: '12px',
          }}
        >
          {t('v_detail.btn_delete')}
        </Typography>
      )}
      <DialogBox
        onClose={handleCancelPopup}
        ref={refDialog}
        action={false}
        open={open}
        title=""
        text={` ${t('fleets.box_text')} ${name}`}
        handleClose={handlePopup}
        handleCancelBox={handleCancelPopup}
      />
    </>
  )
}

export default DeleteFleet
